import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal, MaskedLines } from "../components/Motion";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LanguageContext";
import { SITE_URL } from "../data/content";

export default function Services() {
  const { t, data } = useLang();
  const s = t.services;
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Language Services",
    itemListElement: data.SERVICES.map((sv, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item: {
        "@type": "Service",
        name: sv.title,
        description: sv.answer,
        url: `${SITE_URL}/services/${sv.slug}`,
        provider: { "@type": "ProfessionalService", name: "SG Language Services LLC" }
      }
    }))
  };

  return (
    <>
      <Seo title={s.seoTitle} description={s.seoDesc} path="/services" schema={schema} />
      <section className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-24 texture-grain" data-testid="services-page">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-periwinkle-deep mb-6">{s.kicker}</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[1.0] tracking-tight max-w-4xl">
          <MaskedLines lines={s.heroLines} />
        </h1>
        <p className="mt-8 text-muted2 leading-relaxed max-w-2xl">{s.intro}</p>

        <div className="mt-20 space-y-6">
          {data.SERVICES.map((sv, i) => (
            <Reveal key={sv.slug} delay={i * 0.05}>
              <Link
                to={`/services/${sv.slug}`}
                data-testid={`service-list-item-${sv.slug}`}
                className="group grid md:grid-cols-12 gap-8 items-center bg-white border border-ink/10 rounded-lg p-8 lg:p-12 hover:border-periwinkle transition-colors duration-300"
              >
                <p className="font-mono text-lg text-periwinkle-deep md:col-span-1">{sv.num}</p>
                <div className="md:col-span-4 overflow-hidden rounded-md">
                  <img src={sv.image} alt={sv.title} className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="md:col-span-7">
                  <h2 className="font-serif text-3xl lg:text-4xl font-semibold flex items-center gap-3">
                    {sv.title}
                    <ArrowUpRight size={22} className="text-periwinkle-deep opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </h2>
                  <p className="text-sm text-muted2 leading-relaxed mt-3 max-w-xl">{sv.short}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
